import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import DraggableWindow from './DraggableWindow';
import CustomSelect from '../CustomSelect';
import { caixasService, lojasService } from '../../services/api';

const WindowCaixasPendentes = ({ onClose, onMinimize, isMinimized, zIndex, onFocus, userData }) => {
  const [filial, setFilial] = useState(userData.loja_id || 22);
  const [lojas, setLojas] = useState([]);

  const [caixas, setCaixas] = useState([]);
  const [loadingCaixas, setLoadingCaixas] = useState(false);

  const [pedidoManual, setPedidoManual] = useState('');
  const [caixaManual, setCaixaManual] = useState('');

  const [loadingProdutos, setLoadingProdutos] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [estoqueMap, setEstoqueMap] = useState({});
  const [caixaSelecionada, setCaixaSelecionada] = useState(null);
  const [modalAberto, setModalAberto] = useState(false);
  const [avisoErro, setAvisoErro] = useState('');

  const abrirAvisoErro = (mensagem) => {
    setAvisoErro(mensagem);
  };

  const fecharAvisoErro = () => {
    setAvisoErro('');
  };

  const fecharModalProdutos = () => {
    setModalAberto(false);
    setProdutos([]);
    setCaixaSelecionada(null);
  };

  useEffect(() => {
    const carregarLojas = async () => {
      try {
        const lojasResponse = await lojasService.getLojas();
        const lojasOrdenadas = (lojasResponse || []).sort((a, b) => a.numero - b.numero);
        setLojas(lojasOrdenadas);
      } catch (err) {
        console.error('Erro ao carregar lojas:', err);
      }
    };

    carregarLojas();
  }, []);

  const carregarCaixasPendentes = async (e) => {
    if (e) e.preventDefault();

    setAvisoErro('');
    setCaixas([]);
    setProdutos([]);
    setEstoqueMap({});
    setCaixaSelecionada(null);

    if (!filial) {
      abrirAvisoErro('Selecione uma loja.');
      return;
    }

    setLoadingCaixas(true);
    try {
      const data = await caixasService.buscarCaixasPendentes(filial);
      setCaixas(Array.isArray(data) ? data : []);
      if (!data || data.length === 0) {
        abrirAvisoErro('Nenhuma caixa pendente encontrada para esta loja.');
      }
    } catch (err) {
      console.error('Erro ao carregar caixas pendentes:', err);
      abrirAvisoErro('Erro ao buscar caixas pendentes. Tente novamente.');
    } finally {
      setLoadingCaixas(false);
    }
  };

  const carregarProdutosDaCaixa = async ({ pedido, caixa, cdemp = 1, cdfil = null }) => {
    setAvisoErro('');
    setProdutos([]);
    setEstoqueMap({});

    if (!pedido || !caixa) {
      abrirAvisoErro('Informe pedido e caixa para consultar os produtos.');
      return;
    }

    setLoadingProdutos(true);
    try {
      const data = await caixasService.buscarProdutosDaCaixa({
        filial: cdfil || filial,
        pedido,
        caixa,
        cdemp,
        filialDestino: filial
      });

      setProdutos(Array.isArray(data) ? data : []);
      setCaixaSelecionada({ pedido, caixa, cdemp });

      if (Array.isArray(data) && data.length > 0) {
        setModalAberto(true);
        const codigos = [...new Set(data.map((p) => p.CDPRODU))];
        const estoques = await caixasService.buscarEstoqueProdutos(filial, codigos);
        const map = {};
        (estoques || []).forEach((e) => {
          map[String(e.CDPRODU)] = parseFloat(e.ESTOQ || 0);
        });
        setEstoqueMap(map);
      } else {
        setModalAberto(false);
        abrirAvisoErro('Nenhum produto encontrado para este pedido/caixa.');
      }
    } catch (err) {
      console.error('Erro ao buscar produtos da caixa:', err);
      setModalAberto(false);
      abrirAvisoErro('Erro ao buscar produtos da caixa.');
    } finally {
      setLoadingProdutos(false);
    }
  };

  const handleBuscarManual = async (e) => {
    e.preventDefault();
    await carregarProdutosDaCaixa({
      pedido: pedidoManual.trim(),
      caixa: caixaManual.trim(),
      cdemp: 1
    });
  };

  const getBadgeDias = (dias) => {
    if (dias >= 6) {
      return { background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca', label: `${dias} dias` };
    }
    if (dias === 5) {
      return { background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', label: '5 dias' };
    }
    return { background: '#e0f2fe', color: '#0c4a6e', border: '1px solid #bae6fd', label: `${dias} dias` };
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) return String(value);
    return dateObj.toLocaleDateString('pt-BR');
  };

  return (
    <DraggableWindow
      title="Caixas Pendentes"
      icon="fa-box-open"
      onClose={onClose}
      onMinimize={onMinimize}
      isMinimized={isMinimized}
      zIndex={zIndex}
      onFocus={onFocus}
      initialWidth={980}
      initialTop={70}
      initialLeft={320}
    >
      <form onSubmit={carregarCaixasPendentes} className="consulta-form" style={{ marginBottom: '14px' }}>
        <div className="consulta-form-group" style={{ marginBottom: '10px' }}>
          <label>Loja (Filial)</label>
          <CustomSelect
            options={lojas.map((loja) => ({ value: loja.numero, label: `${loja.numero} - ${loja.nome}` }))}
            value={filial}
            onChange={setFilial}
            placeholder="Selecione a loja..."
            searchPlaceholder="Buscar loja..."
          />
        </div>
        <button type="submit" className="consulta-btn-submit" disabled={loadingCaixas}>
          <i className="fas fa-boxes"></i> Carregar Caixas Pendentes
        </button>
      </form>

      <form onSubmit={handleBuscarManual} className="consulta-form" style={{ marginBottom: '18px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '10px', alignItems: 'end' }}>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>Número do Pedido</label>
            <input
              type="text"
              value={pedidoManual}
              onChange={(e) => setPedidoManual(e.target.value)}
              placeholder="Ex: 3112207"
            />
          </div>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>Número da Caixa</label>
            <input
              type="text"
              value={caixaManual}
              onChange={(e) => setCaixaManual(e.target.value)}
              placeholder="Ex: 78631"
            />
          </div>
          <button type="submit" className="consulta-btn-submit" disabled={loadingProdutos} style={{ height: '46px' }}>
            <i className="fas fa-search"></i> Ver Produtos
          </button>
        </div>
      </form>

      {loadingCaixas && (
        <div className="consulta-loading" style={{ marginTop: 10 }}>
          <i className="fas fa-spinner fa-spin"></i> Buscando caixas pendentes...
        </div>
      )}

      {caixas.length > 0 && (
        <div className="caixas-section">
          <h4 className="caixas-section-title">
            <i className="fas fa-box"></i> {caixas.length} caixa(s) pendente(s)
          </h4>
          <div className="caixas-table-container">
            <table className="caixas-table caixas-table--pendentes">
              <thead>
                <tr>
                  <th>Origem</th>
                  <th>Pedido</th>
                  <th>Caixa</th>
                  <th>Data</th>
                  <th>Dias</th>
                  <th className="caixas-actions-col">Ação</th>
                </tr>
              </thead>
              <tbody>
                {caixas.map((item, idx) => {
                  const badge = getBadgeDias(parseInt(item.DIAS_PENDENTE || 0, 10));
                  const ativo = caixaSelecionada && String(caixaSelecionada.pedido) === String(item.NRPEDIDO) && String(caixaSelecionada.caixa) === String(item.CAIXA);

                  return (
                    <tr
                      key={`${item.NRPEDIDO}-${item.CAIXA}-${idx}`}
                      onClick={() => setCaixaSelecionada({ pedido: item.NRPEDIDO, caixa: item.CAIXA, cdemp: item.CDEMP || 1, cdfil: item.CDFIL })}
                      onDoubleClick={() => carregarProdutosDaCaixa({ pedido: item.NRPEDIDO, caixa: item.CAIXA, cdemp: item.CDEMP || 1, cdfil: item.CDFIL })}
                      className={`caixas-row ${ativo ? 'active' : ''}`}
                      title="Clique duas vezes para ver os produtos"
                    >
                      <td>{item.CDFIL || '-'}</td>
                      <td className="is-strong">{item.NRPEDIDO}</td>
                      <td>{item.CAIXA}</td>
                      <td>{formatDate(item.DATA)}</td>
                      <td>
                        <span className="caixas-badge" style={badge}>
                          {badge.label}
                        </span>
                      </td>
                      <td className="caixas-actions-col">
                        <button
                          type="button"
                          className="caixas-action-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            carregarProdutosDaCaixa({ pedido: item.NRPEDIDO, caixa: item.CAIXA, cdemp: item.CDEMP || 1, cdfil: item.CDFIL });
                          }}
                        >
                          <i className="fas fa-arrow-right"></i> Ver produtos
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modalAberto && createPortal(
        <div className="caixas-sheet-backdrop caixas-sheet-backdrop--produtos" onClick={fecharModalProdutos}>
          <div className="caixas-sheet caixas-sheet--produtos" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Produtos da caixa">
            <div className="caixas-sheet-header">
              <div className="caixas-sheet-title">
                <i className="fas fa-list"></i>
                <div>
                  <div className="caixas-sheet-title-main">Produtos da caixa</div>
                  <div className="caixas-sheet-title-sub">
                    Caixa {caixaSelecionada?.caixa} · Pedido {caixaSelecionada?.pedido}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="caixas-sheet-close"
                onClick={fecharModalProdutos}
                aria-label="Fechar"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="caixas-sheet-body">
              {loadingProdutos ? (
                <div className="consulta-loading">
                  <i className="fas fa-spinner fa-spin"></i> Buscando produtos…
                </div>
              ) : produtos.length === 0 ? (
                <div className="consulta-placeholder">
                  <i className="fas fa-box-open"></i>
                  <p>Nenhum produto encontrado.</p>
                </div>
              ) : (
                <div className="caixas-sheet-table-wrap">
                  <table className="caixas-table produtos">
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Produto</th>
                        <th className="text-right">Qtd</th>
                        <th className="text-right">Estoque (filial {filial})</th>
                        <th>Barras</th>
                      </tr>
                    </thead>
                    <tbody>
                      {produtos.map((p, idx) => {
                        const qtd = parseFloat(p.QTD || 0);
                        const estoque = parseFloat(estoqueMap[String(p.CDPRODU)] || 0);
                        const estoqueClass = estoque < qtd ? 'estoque-baixo' : 'estoque-ok';
                        return (
                          <tr key={`${p.CDPRODU}-${idx}`}>
                            <td className="is-strong">{p.CDPRODU}</td>
                            <td>{p.NOMEPRO}</td>
                            <td className="text-right">{qtd.toFixed(0)}</td>
                            <td className={`text-right ${estoqueClass}`}>{estoque.toFixed(0)}</td>
                            <td className="mono">{p.BARRA || p.BAR1 || p.BAR2 || '-'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}

      {avisoErro && createPortal(
        <div className="caixas-alert-backdrop" onClick={fecharAvisoErro}>
          <div className="caixas-alert" onClick={(e) => e.stopPropagation()}>
            <div className="caixas-alert-header">
              <span className="caixas-alert-light" aria-hidden="true"></span>
              <div className="caixas-alert-title">Aviso</div>
            </div>
            <div className="caixas-alert-body">
              <i className="fas fa-exclamation-triangle"></i>
              <p>{avisoErro}</p>
            </div>
            <div className="caixas-alert-footer">
              <button type="button" onClick={fecharAvisoErro}>
                OK
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </DraggableWindow>
  );
};

export default WindowCaixasPendentes;
